<template>
  <form
    :id="'external-list' + index"
    :class="{ fade }"
    @submit.prevent="saveItem"
    ref="form"
    class="external-list-card"
  >
    <div class="store-name">
      <div>Loja {{ index + 1 }}</div>
      <div v-if="!hasEmptyListWithOne" class="close-trash" @click="removeItem">
        <img :src="closeTrash" />
      </div>
    </div>
    <div class="columns">
      <div class="column is-one-third has-text-left">
        <b-field
          :type="validation.hasError('name') ? 'is-danger' : null"
          :message="
            validation.hasError('name') ? 'Informe o Nome da Loja' : null
          "
          class="external-list-field"
          label="Nome da Loja"
        >
          <b-autocomplete
            v-model="name"
            :data="storesFiltered"
            clearable
            field="name"
            @select="(option) => (sys = option.id ?? '')"
          >
          </b-autocomplete>
        </b-field>
      </div>
      <div class="column is-two-thirds has-text-left">
        <b-field
          :type="hasUrlErrors || messageUrlErrors ? 'is-danger' : null"
          :message="messageUrlErrors"
          class="external-list-field"
          label="URL (link para lista)"
        >
          <b-input v-model="url"> </b-input>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column is-full has-text-left">
        <button class="add-address" type="button" @click="toggleShowAddress()">
          <i
            class="fa fa-plus-circle"
            aria-hidden="true"
            style="color: #e583a2; margin-right: 8px"
          ></i
          >Adicionar endereço físico, se houver
        </button>
      </div>
    </div>
    <div class="columns">
      <div
        v-if="showAddress || this.address"
        class="column is-full has-text-left"
      >
        <b-field
          :type="hasAddressErrors ? 'is-danger' : null"
          :message="
            hasAddressErrors ? 'Informe o Endereço Físico ou URL da Loja' : null
          "
          class="external-list-field"
        >
          <b-input v-model="address"> </b-input>
        </b-field>
      </div>
    </div>
    <div class="button-save-list has-text-right">
      <button
        type="submit"
        :disabled="hasFormErrors || !hasChanges || saved"
        class="button is-primary"
      >
        Salvar lista
      </button>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import SimpleVueValidator from 'simple-vue-validator'

import closeTrash from '@/assets/img/trash.svg'

const Validator = SimpleVueValidator.Validator

export default {
  mixins: [SimpleVueValidator.mixin],

  props: {
    index: Number,
    externalList: Array,
    errors: Object,
  },

  data() {
    return {
      sys: '',
      name: '',
      url: '',
      address: '',
      fade: false,
      saved: true,
      showAddress: false,
      closeTrash,
    }
  },

  validators: {
    name(value) {
      this.updateInChanging(this.hasChanges)
      return Validator.value(value).required()
    },
    url(value) {
      this.updateInChanging(this.hasChanges)
      return Validator.value(value)
    },
    address(value) {
      this.updateInChanging(this.hasChanges)
      return Validator.value(value)
    },
  },

  computed: {
    hasEmptyListWithOne() {
      return (
        this.externalList.length === 1 &&
        !this.sys &&
        !this.name &&
        !this.url &&
        !this.address
      )
    },

    elementId() {
      return 'external-list' + this.index
    },

    storesFiltered() {
      return this.$store.state.gifts.storesExternal.filter((store) => {
        return (
          store.name
            .toString()
            .toLowerCase()
            .indexOf(this.name.toLowerCase()) >= 0
        )
      })
    },

    hasUrlErrors() {
      return this.validation.isTouched('url') && !this.address && !this.url
    },

    messageUrlErrors() {
      if (this.errors && this.errors[`presente_externa${this.index + 1}_url`]) {
        return this.errors[`presente_externa${this.index + 1}_url`]
      } else if (this.hasUrlErrors) {
        return 'Informe a URL da Loja ou Endereço Físico'
      }
      return null
    },

    hasAddressErrors() {
      return this.validation.isTouched('address') && !this.address && !this.url
    },

    hasFormErrors() {
      const urlAndAddressEmpty = !this.address && !this.url

      return !this.validation.isPassed('name') || urlAndAddressEmpty
    },

    hasChanges() {
      return (
        this.sys != this.externalList[this.index].sys ||
        this.name != this.externalList[this.index].name ||
        this.url != this.externalList[this.index].url ||
        this.address != this.externalList[this.index].address
      )
    },

    elementsIDToFocusBeforeEachRouter: {
      get() {
        return this.$store.state.app.elementsIDToFocusBeforeEachRouter
      },
      set(payload) {
        this.$store.dispatch(
          'app/setElementsIDToFocusBeforeEachRouter',
          payload
        )
      },
    },
  },

  mounted() {
    this.sys = this.externalList[this.index].sys
    this.name = this.externalList[this.index].name
    this.url = this.externalList[this.index].url
    this.address = this.externalList[this.index].address
  },

  methods: {
    ...mapActions({
      setIsEditing: 'gifts/setIsEditing',
    }),

    fadeComponent() {
      this.fade = true
      setTimeout(() => {
        this.fade = false
      }, 1000)
    },

    validate() {
      return this.$validate().then(
        function (success) {
          if (success) {
            return {
              sys: this.sys,
              name: this.name,
              url: this.url,
              address: this.address,
            }
          }
        }.bind(this)
      )
    },

    saveItem() {
      if (this.name && (this.url || this.address)) {
        this.$emit('save', this.index, {
          sys: this.sys,
          name: this.name,
          url: this.url,
          address: this.address,
        })
        this.saved = true
        this.removeChangesInBeforeEachRouter()
      }
    },

    removeItem() {
      this.$emit('remove', this.index)
      if (this.externalList.length === 1) {
        this.sys = ''
        this.name = ''
        this.url = ''
        this.address = ''
        this.validation.reset()
      }
    },

    updateInChanging(changes) {
      if (changes) {
        this.addChangesInBeforeEachRouter()
        this.setIsEditing(true)
        this.saved = false
      } else {
        this.removeChangesInBeforeEachRouter()
        this.setIsEditing(false)
        this.saved = true
      }
    },

    addChangesInBeforeEachRouter() {
      const hasRegister = this.elementsIDToFocusBeforeEachRouter.find(
        (el) => el === this.elementId
      )
      if (!hasRegister)
        this.elementsIDToFocusBeforeEachRouter.push(this.elementId)
    },

    removeChangesInBeforeEachRouter() {
      this.elementsIDToFocusBeforeEachRouter =
        this.elementsIDToFocusBeforeEachRouter.filter(
          (el) => el != this.elementId
        )
    },

    toggleShowAddress() {
      this.showAddress = !this.showAddress
    },
  },
}
</script>

<style lang="scss">
.fade {
  animation: fade 1s;
  opacity: 1;
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.external-list-card {
  border: 1px solid #dde7f1;
  border-radius: 16px;
  height: auto;
  width: auto;
  margin-bottom: 32px;
  padding: 24px 16px;
  @media screen and (min-width: 480px) {
    padding: 24px;
  }

  @media screen and (min-width: 800px) and (max-width: 1400px) {
    margin-right: 50px !important;
  }
}

.store-name {
  color: $primary;
  font-size: 16px;
  font-weight: 700;
  width: 100%;
  text-align: left;
  justify-content: space-between;
  display: flex;
}

.external-list-field {
  margin-bottom: 0;
  .label {
    display: block;
    margin-top: 16px;
    text-align: left;
    margin-bottom: 8px;
    color: $neutral;
    font-size: 16px;
    font-weight: 700;
  }

  .input {
    background: #ffffff;
    border: 1px solid rgba(180, 197, 214, 0.5);
    border-radius: 8px;
    height: 52px;
    width: 100%;
    padding-left: 10px;
    color: $neutral;
    &.is-danger {
      border-color: $error;
    }
  }

  .help.is-danger {
    color: $error;
  }

  .control.has-icons-right .icon.is-right {
    top: 3.5px;
    font-size: 20px;
  }
}

.close-trash {
  cursor: pointer;
  display: flex;
  gap: 5px;
  font-size: 14px;
  align-items: center;
  z-index: 1;
}

.add-address {
  padding: 0;
  color: $neutral;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  border: none;
  background-color: transparent;
}

.button-save-list {
  margin-top: 1.5rem;
  @media screen and (min-width: 768px) {
    margin-top: 0;
  }
  .button {
    min-width: 127px;
    min-height: 48px;
    font-size: 16px;
    @media screen and (min-width: 480px) {
      max-width: 155px;
    }
  }
}

.external-list-input:focus-visible {
  border: 2px solid rgba(180, 197, 214, 0.8);
  outline: none !important;
}
</style>
